import React from 'react';
import EmbedModule from '../EmbedModule';
import { Figure, MediaPlayer } from '../../../../ui';
import styled from 'styled-components';
import AudioPlayer from '../../../../ui/MediaPlayer/AudioPlayer';

const Container = styled.div`
  margin-bottom:20px;
`
//how data can look like depending if it is from captionFiles:
// data = { id, name, type, url }
// or frontend :
// data = {provider, id}

const TaskHeaderMedia = ({data, themeColor}) => {

  return (
  <Container>
    { data.type?.includes('video') ?
      <MediaPlayer previewContent={data.url} themeColor={themeColor}/>
        : data.type?.includes('image') ?  
        <Figure.Rectangle $objectfit='contain'><img alt={'header material'} src={data.url} /></Figure.Rectangle>
          : data.type?.includes('audio') ?
          <AudioPlayer url={data.url} themeColor={themeColor} />
        : data.type === 'external' || data.provider ?
          <EmbedModule params={data} />
      : <div>{'[Show Media] ' + data.type}</div>
    }
  </Container>
  )
};

export default TaskHeaderMedia;
